export const copiarUrlPortapapeles = () =>{
    const urlActual = window.location.href;

    return navigator.clipboard.writeText(urlActual)
        .then(() => {
            console.log("¡URL copiada con éxito!");
        })
        .catch(err => {
            console.error("Error al copiar la URL: ", err);
        });
}